<h2 class="pb-4">Top Reads</h2>
@if (topReadsDescription) {
    <div class="mb-6 mt-2 max-w-4xl md:px-8">
        <app-rich-text-document
            [document]="topReadsDescription?.json"></app-rich-text-document>
    </div>
}
<div
    class="grid grid-cols-1 items-stretch justify-center gap-8 md:grid-cols-2 md:px-8 lg:grid-cols-3">
    @for (article of articles; track article.sys.id) {
        <app-knowledge-article-card
            class="flex justify-center"
            [article]="article"
            [lazy]="false">
        </app-knowledge-article-card>
    }
</div>
